import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import styles from './TaskListItem.m.sass';
import CompletionToggle from '../CompletionToggle';
var TaskListItem = function TaskListItem(_ref) {
  var item = _ref.item;
  var task = item.task;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.item, item.isLastInList && styles.last, task.completed && styles.completed)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.itemInner
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.title,
    title: task.title
  }, task.title), task.description && /*#__PURE__*/React.createElement("p", {
    className: styles.description,
    title: task.description
  }, task.description)), /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, (item.canComplete || task.completed) && /*#__PURE__*/React.createElement(CompletionToggle, {
    completed: task.completed,
    onClick: item.toggleCompletion,
    avatar: task.completed ? task.completedBy.avatar : null,
    readOnly: !item.canComplete,
    processing: item.toggleCompletion.pending,
    pulse: item.isNextIncompleteTask && item.canComplete,
    title: task.completed ? "".concat(task.completedBy.displayName, " @ ").concat(task.dateCompleted.format('LL LT')) : 'Click to mark this task completed'
  }))));
};
export default observer(TaskListItem);
//# sourceMappingURL=index.js.map
